<template>
  <div class="suspension-notice">
    <h3 class="suspension-notice-title">{{ title }}</h3>
    <div class="suspension-notice-body" v-html="body"></div>
  </div>
</template>

<script>
export default {
  props: {
    noticeType: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      htmlParams: {
        'plan-information': this.$t('plan_info'),
        'plan-information-url': this.$router.resolve({ name: 'plan-information' }).href,
        'member-information': this.$t('confirm_login_information'),
        'member-information-url': this.$router.resolve({ name: 'Client Member Information' }).href,
        'carry-business-property': this.$t('h3_carry-business-property'),
        'purchase-option': this.$t('label_purchase-option')
      }
    }
  },
  computed: {
    title: function () {
      switch (this.noticeType) {
        case 'unpaid':
          return this.$t('h3_suspension-notice')
        default:
          return this.$t('h3_suspension-notice-capacity-over')
      }
    },
    body: function () {
      switch (this.noticeType) {
        case 'unpaid':
          return this.$t('html_suspension-notice', this.htmlParams)
        default:
          return this.$t('html_suspension-notice-capacity-over', this.htmlParams)
      }
    }
  }
}
</script>

<style scoped>
.suspension-notice{
  background-color: #FEF2EF;
  padding: 1.5em;
  margin-top: 60px;
}
.suspension-notice-title{
  font-size: 1.5em;
  font-weight: bold;
  color: #EA6031;
  text-align: center;
}
@media screen and (max-width: 768px){
  .suspension-notice{
    padding: 1em;
    font-size: .875em;
    margin-top: 32px;
  }
}
</style>
<style>
.suspension-notice-body p{
  margin-top: 2em;
}
.suspension-notice-body ol{
  counter-reset: number 0;
}
.suspension-notice-body ol li{
  font-weight: bold;
  margin-top: 1em;
}
.suspension-notice-body ol li::before{
  counter-increment: number;
  content: counter(number)'. ';
  color: #EA6031;
}
.suspension-notice-body ol li p,
.suspension-notice-body p + p{
  margin-top: .5em;
}
.suspension-notice-body a{
  text-decoration: underline;
}
@media screen and (max-width: 768px){
  .suspension-notice-body p{
    margin-top: 1.5em;
  }
}
</style>
